var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17C23 20.31 20.31 23 17 23V21.5C19.5 21.5 21.5 19.5 21.5 17H23ZM0.999995 7C0.999995 3.69 3.69 1 7 1V2.5C4.5 2.5 2.49999 4.5 2.49999 7H0.999995ZM8 4.32L3.41 8.92C0.189995 12.14 0.189995 17.37 3.41 20.59C6.63 23.81 11.86 23.81 15.08 20.59L22.15 13.5C22.64 13.03 22.64 12.24 22.15 11.75C22.0339 11.6336 21.8959 11.5412 21.7441 11.4782C21.5922 11.4152 21.4294 11.3828 21.265 11.3828C21.1006 11.3828 20.9378 11.4152 20.7859 11.4782C20.634 11.5412 20.4961 11.6336 20.38 11.75L15.96 16.17L15.25 15.46L21.79 8.92C22.28 8.43 22.28 7.64 21.79 7.15C21.3 6.66 20.5 6.66 20 7.15L14.19 13L13.5 12.27L20.37 5.38C20.86 4.89 20.86 4.1 20.37 3.61C19.88 3.12 19.09 3.12 18.6 3.61L11.71 10.5L11 9.8L16.5 4.32C17 3.83 17 3.04 16.5 2.55C16 2.06 15.22 2.06 14.73 2.55L7.11 10.17C7.70726 10.9394 8.00328 11.9002 7.94252 12.8723C7.88176 13.8444 7.46841 14.761 6.78 15.45L6.07 14.74C6.6318 14.1775 6.94736 13.415 6.94736 12.62C6.94736 11.825 6.6318 11.0625 6.07 10.5L5.72 10.15L9.79 6.08C10.28 5.59 10.28 4.8 9.79 4.31C9.29 3.83 8.5 3.83 8 4.32Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.838d572b0b17b970e0d68021b0ba0cfc.svg";
export { ForwardRef as ReactComponent };